module.exports = __webpack_public_path__ + "img/leadIntegrated.14525a9c.svg";